import React from 'react';

import styles from './AuctionTooltipContent.css';

export const AuctionTooltipContent: React.FC<React.PropsWithChildren> = ({ children }) => (
  <div className={styles['cont']}>{children}</div>
);
